import { isEmpty } from 'lodash';

export const GET_POSTCODE_PLAN_OBJECTIVES_PENDING = 'GET_POSTCODE_PLAN_OBJECTIVES_PENDING';
export const GET_POSTCODE_PLAN_OBJECTIVES_FULFILLED = 'GET_POSTCODE_PLAN_OBJECTIVES_FULFILLED';
export const GET_POSTCODE_PLAN_OBJECTIVES_REJECTED = 'GET_POSTCODE_PLAN_OBJECTIVES_REJECTED';
export const GET_POSTCODE_PLAN_PENDING = 'GET_POSTCODE_PLAN_PENDING';
export const GET_POSTCODE_PLAN_FULFILLED = 'GET_POSTCODE_PLAN_FULFILLED';
export const GET_POSTCODE_PLAN_REJECTED = 'GET_POSTCODE_PLAN_REJECTED';
export const GET_POSTCODE_PLAN_META_PENDING = 'GET_POSTCODE_PLAN_META_PENDING';
export const GET_POSTCODE_PLAN_META_FULFILLED = 'GET_POSTCODE_PLAN_META_FULFILLED';
export const GET_POSTCODE_PLAN_META_REJECTED = 'GET_POSTCODE_PLAN_META_REJECTED';
export const ADD_POSTCODE_PLAN_PENDING = 'ADD_POSTCODE_PLAN_PENDING';
export const ADD_POSTCODE_PLAN_FULFILLED = 'ADD_POSTCODE_PLAN_FULFILLED';
export const ADD_POSTCODE_PLAN_REJECTED = 'ADD_POSTCODE_PLAN_REJECTED';
export const UPDATE_POSTCODE_PLAN_PENDING = 'UPDATE_POSTCODE_PLAN_PENDING';
export const UPDATE_POSTCODE_PLAN_FULFILLED = 'UPDATE_POSTCODE_PLAN_FULFILLED';
export const UPDATE_POSTCODE_PLAN_REJECTED = 'UPDATE_POSTCODE_PLAN_REJECTED';

function determineOutletEligibility(payload) {
  if (isEmpty(payload.zones) && isEmpty(payload.groups)) {
    return 'postcodes';
  }

  if (isEmpty(payload.zones) && isEmpty(payload.postcodes)) {
    return 'groups';
  }

  if (isEmpty(payload.postcodes) && isEmpty(payload.groups)) {
    return 'zones';
  }

  return '';
}

const initialState = {
  postcode_plan: { outletEligibility: '' },
  postcode_plan_objectives: [],
  meta: {},
  fetching: false,
  fetched: false,
  errors: {}
};

export default function postcodePlanReducer(state = initialState, action) {
  switch (action.type) {
    case GET_POSTCODE_PLAN_PENDING:
    case GET_POSTCODE_PLAN_OBJECTIVES_PENDING: {
      return {
        ...initialState,
        fetching: true,
        fetched: false
      };
    }
    case ADD_POSTCODE_PLAN_PENDING:
    case GET_POSTCODE_PLAN_META_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_POSTCODE_PLAN_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        postcode_plan: { ...action.payload, outletEligibility: determineOutletEligibility(action.payload) }
      };
    }
    case ADD_POSTCODE_PLAN_FULFILLED: {
      return {
        ...state
      };
    }
    case GET_POSTCODE_PLAN_META_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        meta: action.payload
      };
    }
    case GET_POSTCODE_PLAN_OBJECTIVES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        postcode_plan_objectives: action.payload.data
      };
    }
    case GET_POSTCODE_PLAN_REJECTED:
    case ADD_POSTCODE_PLAN_REJECTED:
    case GET_POSTCODE_PLAN_META_REJECTED:
    case GET_POSTCODE_PLAN_OBJECTIVES_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        errors: action.payload
      };
    }
    default: {
      return { ...state };
    }
  }
}
